import React from "react";
import classNames from "classnames";

import { BrandLicense } from "custom-types/Brand";

type Props = {
  brandLicenses: Array<BrandLicense>;
};

const BrandLicenses: React.FC<Props> = ({ brandLicenses }) => {
  return (
    <div className="mt-md grid grid-cols-[minmax(0px,_515px)]">
      <p className="text-xs font-extrabold uppercase mb-sm">State License(s)</p>
      <ul className="md:flex md:flex-wrap">
        {brandLicenses.map((license: BrandLicense, idx: number) => (
          <li data-testid="brand-license" key={license.licenseNumber}>
            {license.licenseNumber}
            <span
              className={classNames("px-2 hidden md:inline-flex", {
                "md:hidden": idx === brandLicenses.length - 1,
              })}
              aria-hidden="true"
            >
              |
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BrandLicenses;
